import { render, staticRenderFns } from "./FormNoteContent.vue?vue&type=template&id=4d44a1ed&"
import script from "./FormNoteContent.vue?vue&type=script&lang=js&"
export * from "./FormNoteContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports